import AboutUs from "@/pages/AboutUs.vue";
import HomePage from "@/pages/HomePage.vue";
import AkadSafety from "@/pages/AkadSafety.vue";
import AkadTerms from "@/pages/AkadTerms.vue";
import PrivacyPolicy from "@/pages/PrivacyPolicy.vue";
import SellingPolicy from "@/pages/SellingPolicy.vue";
import { createRouter, createWebHistory } from "vue-router";


const routes = [
    { path: "/", component: HomePage },
    { path: "/about-us", component: AboutUs },
    { path: "/akad-terms", component: AkadTerms },
    { path: "/akad-safety", component: AkadSafety },
    { path: "/privacy-policy", component: PrivacyPolicy },
    { path: "/selling-privacy-policy", component: SellingPolicy },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to) => {
    console.log('Navigating to:', to.fullPath);
});

export default router;
